const MensajeVar = {
    variant: {
        snackbar: {
            DEFAULT: "default",
            SUCCESS: "success",
            ERROR: "error",
            INFO: "info",
            WARNING: "warning",
        },
    },
    snackConfig: {
        defecto: {
            vertical: "top",
            horizontal: "center",
        },
    },
    mensaje: {
        REQUERIDO: "Este campo es requerido",
    },
};
export default MensajeVar;
